import React from 'react';

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="text-3xl font-heading font-bold text-primary-600">FounderMind AI</span>
          <p className="text-neutral-500 mt-1 text-sm">Bootcamp Assessment Platform</p>
        </div>
        {children}
      </div>
    </div>
  );
}
